import React from 'react';
import { Helmet } from 'react-helmet';

const MatomoTrackingScript = () => {
  const containerId = process.env.REACT_APP_MATOMO_CONTAINER_ID || 'J2NZsGdI';
  return (
    <Helmet>
      <script>
        {` var _mtm = (window._mtm = window._mtm || []);
            _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });
            (function () {
                var d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
                g.async = true;
                g.src = 'https://walmart-analytics.emperia-staging.com/js/container_${containerId}.js';
                s.parentNode.insertBefore(g, s);
            })();`}
      </script>
    </Helmet>
  );
};

export default MatomoTrackingScript;
